<template>
    <div
        :class="['picture-item', imgError, active]"
        :data-postId="data.id"
        ref="pictureItem"
        :style="reload_img(data.thumbnail)"
    >
        <div class="cards" @mouseenter="operat_show" @mouseleave="operat_hide">
            <img :src="data.thumbnail" ref="cardsImg" />
            <span
                class="video-timer"
                v-if="data.mimeType && data.mimeType.includes('vid')"
            >
                {{ data.duration }}
            </span>

            <label @click.stop="0" v-if="operatShow || isChecked">
                <input
                    type="checkbox"
                    name="choose"
                    class="checkbox"
                    ref="checkbox"
                    v-model="isChecked"
                    @change="checkeds($event)"
                />
                <span></span>
            </label>

            <div class="user-operat notranslate" v-if="operatShow">
                <v-btn
                    class="collect-btn icon-btn icon-information"
                    v-if="data.notes"
                    @click.stop="$emit('emitInformationShow', data.id)"
                >
                    <v-icon>mdi-information-outline</v-icon>
                </v-btn>
                <v-btn
                    v-if="!$store.state.global.isNewBeveliver"
                    :class="[
                        'collect-btn icon-btn',
                        data.isFavorited && 'turned',
                    ]"
                    @click.stop="favorites"
                >
                    <v-icon class="turned-out">mdi-bookmark-outline</v-icon>
                    <v-icon class="turned-in">mdi-bookmark</v-icon>
                </v-btn>
                <div class="operat-bottom">
                    <v-btn
                        :class="['like-btn icon-btn', data.isLikes && 'favor']"
                        @click.stop="likes($event)"
                    >
                        <v-icon class="notlikes">mdi-thumb-up-outline</v-icon>
                        <v-icon class="likes">mdi-thumb-up</v-icon>
                        <span v-if="data.likes">{{ data.likes }}</span>
                    </v-btn>
                    <v-btn
                        class="down-btn icon-btn"
                        @click.stop="
                            download(data.download_url, data.fileId, data.name)
                        "
                    >
                        <i class="v-icon" v-html="$P.downloadIcon"></i>
                        <span v-if="data.downloads">{{ data.downloads }}</span>
                    </v-btn>
                </div>
            </div>
        </div>

        <p
            class="poster-title"
            @mouseenter="show_title($event, data.name)"
            @mouseleave="hide_title($event)"
        >
            {{ data.name }}
        </p>
        <information-modal
            ref="notesInformation"
            :notes="data.notes"
        ></information-modal>
    </div>
</template>

<script>
import { render_img, download_picture, timeout } from "@/utils/util.js";
import { favoritesFn } from "@/utils/favorites.js";
import { likesFn } from "@/utils/likes.js";
import { downloads } from "@/api/interface.js";
import { mapState, mapMutations } from "vuex";
import informationModal from "@/components/information-modal/index";

export default {
    name: "picture-item",
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            },
        },
        dataAmount: {
            type: Number,
            default: 0,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            imgError: "",
            openView: "",
            active: "",
            checked: false,
            isLike: false,
            loadError: false,
            operatShow: false,
            isChecked: false,
            isCopyImg: true,
            timer: null,
        };
    },
    components: {
        informationModal,
    },
    computed: {
        ...mapState("download", ["downCount"]),
        ...mapState("mixins", ["isAllSelect"]),
    },
    watch: {
        isAllSelect(newData) {
            this.isChecked = newData;
        },
    },
    created() {
        this.data.likes =
            parseInt(this.data.likes) > 999
                ? "999+"
                : parseInt(this.data.likes);
        this.data.downloads =
            parseInt(this.data.downloads) > 999
                ? "999+"
                : parseInt(this.data.downloads);
    },
    mounted() {
        window.downloads = [];
        this.$P.$on("successDownload", () => {
            this.$refs.pictureItem.classList.remove("checked");
            if (this.$refs.checkbox) {
                this.$refs.checkbox.checked = false;
                this.isChecked = false;
            }
            this.updateAllSelect(false);
        });
        //  批量下载
        this.$P.$on("createAllDownload", (fileId) => {
            if (this.data.id === fileId) {
                this.download(this.data.download_url, this.data.fileId);
            }
        });
    },
    methods: {
        ...mapMutations("download", ["updateDownAmount", "updateDownCount"]),
        ...mapMutations("mixins", ["updateAllSelect"]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),

        async reload_img(url) {
            try {
                await render_img(url);
            } catch (e) {
                this.imgError = "errors";
            }
        },

        async update_download_data(isChecked, postId) {
            if (isChecked) {
                //  如果数组不为空时防止重复添加
                this.updateDownCount({
                    postId: this.data.id,
                    downUrl: this.data.download_url,
                    name: this.data.name,
                });
            } else {
                //  取消选择时删除当前数据
                this.downCount.forEach((item, i) => {
                    if (item.postId === postId) {
                        this.downCount.splice(i, 1);
                    }
                });
            }
            await timeout(100);
            this.updateDownAmount(this.downCount.length);
        },

        //  点赞
        async likes(ev) {
            let likesData = await likesFn(
                ev,
                this.data.isLikes,
                this.data.likes,
                this.data.fileId
            );
            this.data.isLikes = likesData.isLikes;
            this.data.likes = likesData.likeNum;
            this.$emit(
                "likes",
                this.data.id,
                this.data.isLikes,
                this.data.likes
            );

            this.close_information_modal();
        },

        //  下载
        async download(url, fileId, name) {
            let { data } = await downloads({ fileIds: [fileId] });
            // window.location.href = url;
            download_picture(url, name);
            if (String(this.data.downloads).includes("+")) return;
            this.data.downloads++;
            this.data.downloads =
                this.data.downloads > 999 ? "999+" : this.data.downloads;

            this.close_information_modal();
        },

        //  收藏
        favorites() {
            favoritesFn(
                this.data.isFavorited,
                this.data.id,
                this.data.favorite_id,
                this.data.thumbnail
            );

            this.close_information_modal();
        },
        //  复选框选择
        checkeds(ev) {
            let el = ev.target;
            if (el.checked) {
                el.checked = true;
                this.isChecked = true;
                el.closest(".picture-item").classList.add("checked");
            } else {
                el.checked = false;
                this.isChecked = false;
                el.closest(".picture-item").classList.remove("checked");
            }
            this.update_download_data(
                ev.target.checked,
                this.data.id,
                this.data.name
            );
            this.dataAmount === this.downCount.length &&
                this.updateAllSelect(true);
            this.downCount.length <= 0 && this.updateAllSelect(false);

            this.close_information_modal();
        },

        operat_show() {
            this.operatShow = true;
            this.create_big_img(true);
        },

        operat_hide() {
            this.operatShow = false;
            this.create_big_img(false);
        },

        show_title(ev, title) {
            $(ev.target).attr("title", title);
        },

        hide_title(ev) {
            $(ev.target).removeAttr("title");
        },
        // 更新图片选中状态
        update_checkbox_state(ev) {},

        async create_big_img(isAdd) {
            let bigUrl = `https://lh3.googleusercontent.com/d/${this.data.fileId}`;
            if (isAdd && this.isCopyImg) {
                this.timer = setTimeout(() => {
                    $(this.$refs.cardsImg).attr("src", bigUrl);
                    this.isCopyImg = false;
                    this.$refs.cardsImg.onload = async () => {
                        // this.updateSnackbar("可鼠标右键选择复制图片 😊");
                        // await timeout(30);
                        // $(".v-snack__wrapper").addClass("theme--darken-1");
                        $(this.$refs.cardsImg).attr(
                            "title",
                            "💡" + this.$TL.cardCopyHoverTips
                        );
                    };
                }, 1000);
            } else {
                clearTimeout(this.timer);
                // setTimeout(() => {
                //   $(this.$refs.cardsImg).attr("src", this.data.thumbnail);
                //   this.isCopyImg = true;
                // }, 360);
            }
        },

        //  开启卡片信息弹框
        async open_information_modal() {
            this.$refs.notesInformation.open_information();
        },
        //  关闭卡片信息弹框
        close_information_modal() {
            this.$refs.notesInformation.close_information();
        },
    },
};
</script>

<style lang="scss">
.picture-item {
    width: min-content;
    flex-grow: 1;
    margin: 1px;
    margin-bottom: 4px;
    transition: all 0.12s ease;
    cursor: pointer;
    max-width: 100%;
    padding: 8px;
    border: 1px solid transparent;
    border-radius: $border-radius;
    box-sizing: unset;
    position: relative;

    &[active="true"],
    &.checked {
        background-color: #d6e2f5;
        border-color: #2874e5;
    }

    &.errors {
        img {
            opacity: 0;
            visibility: hidden;
        }

        .user-operat {
            display: none !important;
        }

        .cards {
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iNTBweCIgZmlsbD0iIzVmNjM2OCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PGNpcmNsZSBjeD0iMTUuNSIgY3k9IjkuNSIgcj0iMS41Ii8+PGNpcmNsZSBjeD0iOC41IiBjeT0iOS41IiByPSIxLjUiLz48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJzNC40NyAxMCA5Ljk5IDEwQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyUzE3LjUyIDIgMTEuOTkgMnpNMTIgMjBjLTQuNDIgMC04LTMuNTgtOC04czMuNTgtOCA4LTggOCAzLjU4IDggOC0zLjU4IDgtOCA4em0wLTZjLTIuMzMgMC00LjMyIDEuNDUtNS4xMiAzLjVoMS42N2MuNjktMS4xOSAxLjk3LTIgMy40NS0yczIuNzUuODEgMy40NSAyaDEuNjdjLS44LTIuMDUtMi43OS0zLjUtNS4xMi0zLjV6Ii8+PC9zdmc+);

            background: {
                repeat: no-repeat;
                position: center center;
                size: auto;
            }
        }
    }

    &:hover {
        .video-timer {
            opacity: 0;
            visibility: hidden;
        }
    }

    .cards {
        border-radius: $border-radius;
        line-height: 0;
        overflow: hidden;
        background-color: #edeff2;
        position: relative;

        img {
            min-width: 100%;
            height: 184px;
            display: block;
            object-fit: cover;
        }

        .copyimg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            object-fit: cover;
        }
    }

    .poster-title {
        font-size: 14px;
        margin-top: 4px;
        @include limit-line(3, 1.5);
    }

    .video-timer {
        position: absolute;
        font-size: 12px;
        bottom: 4px;
        right: 4px;
        display: block;
        padding: 2px 6px;
        background-color: rgba($color-white, 0.8);
        border-radius: 22px;
        transition: 0.25s ease-in;
        line-height: 1.4em;
    }

    label {
        position: absolute;
        left: 5px;
        top: 4px;
        z-index: 20;

        span {
            position: absolute;
            top: 0;
            box-sizing: border-box;
        }

        input.checkbox {
            &:not(:checked) + span::after {
                background-color: $color-white;
            }
        }
    }

    .user-operat {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;

        .v-btn {
            color: $color-white;
            background-color: $color-white;
            pointer-events: auto;

            .v-btn__content {
                color: $color-font;
            }
        }

        .icon-information {
            right: 38px !important;
            i {
                color: #ff9900;
                font-size: 20px !important;
            }
        }

        .collect-btn {
            position: absolute;
            top: 5px;
            right: 5px;
            z-index: 20;
            i {
                font-size: 19px;
            }
        }

        .operat-bottom {
            @include flex();
            position: absolute;
            bottom: 5px;
            right: 5px;
            z-index: 20;

            .like-btn,
            .down-btn {
                padding: 0 6px;
                span {
                    font-size: 14px;
                    line-height: 1.4;

                    span {
                        padding-left: 4px;
                    }
                }
            }

            .like-btn {
                i {
                    font-size: 18px;
                }
            }

            .down-btn {
                margin-left: 6px;
                svg {
                    width: 18px;

                    path {
                        fill: rgba(0, 0, 0, 0.54);
                    }
                }
            }
        }
    }
}

.layout-large-with-meta,
.layout-large-without-meta {
    .picture-item {
        .cards {
            img {
                height: 184px;
            }
        }
    }
}

.layout-large-with-meta,
.layout-small-with-meta {
    .picture-item {
        .poster-title {
            display: none;
        }
    }
}

.layout-small-without-meta,
.layout-small-with-meta {
    .picture-item {
        .cards {
            img {
                height: 130px;
            }
        }
    }
}

.v-snack__wrapper.theme--darken-1 {
    background-color: #43a047 !important;
    .v-snack__content {
        color: $color-white !important;
        text-align: center;
    }
}
</style>
